import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { updateCat } from "../../../../store/updateData";

export const saveCat = async (params: stdObject) => {
  const {
    t,
    dispatch,
    windowValues,
    setWindowValues,
    modalData,
    setMsg2,
    setModalData2,
    closeMsg,
    logoutAction,
  } = params;
  if (windowValues.NOMCAT.trim() === "") {
    setMsg2("custom2");
    setModalData2({
      code: "warning",
      title: t("p.enterAName"),
    });
  } else {
    setMsg2("loading");
    let payloadSaveCat: stdObject = {
      id: modalData.id,
      info: {
        CODCAT: modalData.id,
        ...windowValues,
      },
      commissions: windowValues.commissions,
    };
    delete payloadSaveCat.info.commissions;
    console.log("payloadSaveCat: ", payloadSaveCat);
    const responseSaveCat: stdObject = await sendData({
      endPoint: "saveCat",
      payload: payloadSaveCat,
      logoutAction,
    });
    console.log("responseSaveCat: ", responseSaveCat);
    if (responseSaveCat.success && responseSaveCat.status) {
      dispatch(
        updateCat({
          newCat: responseSaveCat.new,
          data: responseSaveCat.info[0],
        }),
      );

      closeMsg(2);
      closeMsg();
      setWindowValues({});
    } else {
      setMsg2("error");
    }
  }
};
